import { useCallback, useMemo } from 'react';

import { ChatState, StreamingState, StreamingRefsFull } from './types';
import { processTickerQueue } from './useChatBoxHelpers';

export const useTicker = (
  refsFull: StreamingRefsFull,
  streamingState: StreamingState,
  chatState: ChatState
) => {
  const stopTokenTicker = useCallback(() => refsFull.clearTokenInterval(), [refsFull]);

  const startTokenTicker = useCallback(() => {
    if (refsFull.tokenIntervalRef.current) return;
    const interval = window.setInterval(
      () => processTickerQueue({ refs: refsFull, streaming: streamingState, chat: chatState }, stopTokenTicker),
      50
    );

    refsFull.setTokenInterval(interval);
  }, [refsFull, streamingState, chatState, stopTokenTicker]);

  const enqueueTokens = useCallback((chunk: string) => {
    const tokens = chunk.match(/\S+|\s+/g);

    if (!tokens || tokens.length === 0) return;
    refsFull.pushTokens(tokens);
    startTokenTicker();
  }, [refsFull, startTokenTicker]);

  const resetStreamingDisplayFn = useCallback(() => {
    stopTokenTicker();
    refsFull.clearTokenQueue();
    refsFull.setPendingCompletion(null);
    refsFull.setStreamingMessageId(null);
    streamingState.setCurrentStreamingMsgId(null);
    streamingState.setStreamingDisplay('');
  }, [stopTokenTicker, refsFull, streamingState]);

  return useMemo(() => ({
    stopTokenTicker,
    startTokenTicker,
    enqueueTokens,
    resetStreamingDisplay: resetStreamingDisplayFn
  }), [stopTokenTicker, startTokenTicker, enqueueTokens, resetStreamingDisplayFn]);
};
